module.exports = __webpack_public_path__ + "img/main_bg.17a502d.webp";